export default __webpack_public_path__ + "static/media/touchOne.e5de5847.svg";